import { createSlice } from '@reduxjs/toolkit'
import {
  CARDINAL_LIB_STATUSES,
  CARDINAL_STATUSES,
} from '../../constants/cardinal'

const initialState = {
  cardinalSessionId: null,
  cardinalJwt: null,
  successRedirectUrl: null,
  cardinalStatus: CARDINAL_STATUSES.hasNotInitiated,
  libStatus: CARDINAL_LIB_STATUSES.pending,
  isCardinalCollectingData: false,
  isCardinalInitialised: null,
}

const cardinalCruiseSlice = createSlice({
  name: 'cardinalCruise',
  initialState,
  reducers: {
    cardinalCruiseUpdate: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
})

export const { cardinalCruiseUpdate } = cardinalCruiseSlice.actions

export const cardinalCruiseSelector = state => state.cardinalCruise

export default cardinalCruiseSlice.reducer
